import styled from '@emotion/styled';

export const EventDateWrapper = styled('div', { label: 'EventDateWrapper' })`
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-right: 8px;
    line-height: 1;
`;
